import React from 'react';
import CKEditor from 'ckeditor4-react';
import MessageTemplateStore from './MessageTemplateStore';
import { CKEditorConfig } from '@utils/constants';

class Editor extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      html: this.props.html,
    };
  }

  onChange(evt) {
    var html = evt.editor.getData();
    this.setState({ html });
    MessageTemplateStore.setFieldsValue({
      template: html,
    });
  }

  render() {
    return (
      <CKEditor
        config={CKEditorConfig}
        data={this.state.html}
        onChange={this.onChange}
      />
    );
  }
}
export default Editor;
